import { useState } from 'react';
import type { ReactNode } from 'react';
import track from 'react-tracking';
import { Button } from '@simplywallst/ui-core';
import { DeprecatedTruncator } from '@/components/Truncator';
import { ViewMode } from '@/pages/CompanyReport/enum';
import { useTranslation } from '@/hooks/useTranslation';

interface Props {
  children: ReactNode;
  minHeight?: number;
  viewMode?: ViewMode;
}

const ListTruncator = ({
  children,
  minHeight,
  tracking: { trackEvent },
  viewMode,
}: Props & Tracking) => {
  const [open, setOpen] = useState(viewMode === ViewMode.Print);
  const [tracked, setTracked] = useState(false);
  const t = useTranslation();

  return (
    <>
      <DeprecatedTruncator open={open} minHeight={minHeight || 100}>
        {children}
      </DeprecatedTruncator>
      <Button
        styleType="gentleLarge"
        display="block"
        onClick={() => {
          setOpen(!open);
          trackEvent(
            !tracked
              ? {
                  action: 'click',
                  modifier: 'show_more',
                }
              : false
          );
          setTracked(true);
        }}
        data-cy-id="truncator-button"
      >
        {open
          ? t('app.component.listTruncator.showLess')
          : t('app.component.listTruncator.showMore')}
      </Button>
    </>
  );
};

export default track({
  type: 'track',
})(ListTruncator);
